var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"thumbnail",class:{ 'clickable' : _vm.hasUrl }},[(_vm.hasUrl)?_c('span',{staticClass:"empty"},[_c('i',{staticClass:"fas fa-file-pdf fa-3x"})]):_c('span',{staticClass:"empty"},[_c('i',{staticClass:"fas fa-question fa-3x"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4093052c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/pdf-preview.vue
// module id = null
// module chunks = 